import styled from 'styled-components'
import PropTypes from 'prop-types'
import Link from 'next/link'
import Image from 'next/legacy/image'
import { OutlineButton } from 'common/button'
import { H2 } from 'common/typography'
import ContentRenderer from 'content-renderer'

const ProjectCardStyled = styled.li`
  background-color: var(--basePrimary);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 4px;
  border-radius: 8px;
  overflow: hidden;
  transition: 0.3s ease-in filter;
  &:hover {
    filter: drop-shadow(0px 2px 24px rgba(97, 112, 216, 0.4));
  }
  .card-container {
    height: 100%;
    display: grid;
    row-gap: 8px;
    grid-template-rows: min-content 1fr;
  }
  .btn-container {
    display: flex;
    align-items: flex-end;
    button {
      max-height: 51.59px;
    }
  }
  img {
    max-width: 100%;
    object-fit: cover;
  }
  p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 14px;
    line-height: 24px;
    color: var(--neutral30);
  }
  li {
    display: none;
    &:first-of-type {
      display: block;
    }
  }
  .project-card-container {
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

function ProjectCard({
  title, slug, thumb_image, description: { blocks }, progress_status,
}) {
  return (
    <ProjectCardStyled id={`${slug}-card`} role="region">
      <Link href={`/proyectos/${slug}`} className="card-container">
        <div>
          <Image src={thumb_image} alt={`Thumbnail de ${title}`} width={400} height={230} />
        </div>
        <div className="project-card-container">
          <div className="content-section">
            <H2 fontSize="24" lineHeight="32" color="var(--baseNeutral)">{title}</H2>
            <ContentRenderer color="var(--black50)" chunks={blocks.slice(0, 1)} />
          </div>
          <div className="btn-container">
            <OutlineButton fullWidth radius={4} lineHeight="24px" fontWeight="600" responsive>
              {progress_status?.project_template ? 'Continua el proyecto' : 'Ver proyecto' }
            </OutlineButton>
          </div>
        </div>
      </Link>
    </ProjectCardStyled>
  )
}

ProjectCard.defaultProps = {
  created_at: '',
}

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  thumb_image: PropTypes.string.isRequired,
  is_free: PropTypes.bool.isRequired,
  challenge: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  created_at: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  description: PropTypes.any.isRequired,
}

export default ProjectCard
